import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import * as st from './Tooltip.module.scss'

import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { uniqueId } from '../../utils/utils'

interface TooltipProps extends BaseComponentProps {
  content: React.ReactChild
  position?: 'top' | 'bottom' | 'left' | 'right'
  size?: 's' | 'm' | 'l'
  use?: 'info' | 'success' | 'warning' | 'error' | 'prime'
  tabIndex?: number
  id?: string
  dismissable?: boolean
  startOpen?: boolean
  onDismiss?: () => void
}

export class Tooltip extends React.Component<TooltipProps, {isChecked: boolean, noJS: boolean}> {
  uniqueID: string

  static defaultProps = {
    position: 'top',
    size: 's',
    tabIndex: -1,
    dismissable: false,
    startOpen: false
  }

  constructor(props: TooltipProps) {
    super(props)
    this.uniqueID = `tooltip-${uniqueId()}`
    this.state = {
      isChecked: this.props.startOpen || false,
      noJS: true
    };
  }

  componentDidMount() {
    this.setState({ noJS: false })
    if (!this.props.dismissable) {
      document.documentElement.addEventListener('click', this.uncheckCheckboxState)
    }
  }

  componentWillUnmount() {
    if (!this.props.dismissable) {
      document.documentElement.removeEventListener('click', this.uncheckCheckboxState)
    }
  }

  uncheckCheckboxState = () => {
    if (this.state.isChecked) {
      this.setState({ isChecked: false })
    }
  }

  setCheckboxState = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ isChecked: e.currentTarget.checked })
  }

  render() {
    return (
      <span className={cn(
        st.container,
        'dvui-tooltip-container',
        {
          [st.dismissable]: this.props.dismissable,
          [st.noJS]: this.state.noJS
        }
      )}
      tabIndex={this.props.tabIndex}>
        <input className={st.hidden} type="checkbox" id={this.props.id || this.uniqueID}
          checked={this.state.isChecked}
          onChange={this.setCheckboxState}
        />
        <label htmlFor={this.props.id || this.uniqueID} className={st.subject}>
          {this.props.children}
        </label>
        <span className={extractClassNamesFromProps(
          this.props,
          st.tooltip,
          st[`position-${this.props.position}`],
          st[`size-${this.props.size}`],
          {
            [st[this.props.use || '']]: Boolean(this.props.use)
          },
          'dvui-tooltip'
        )}>
          {this.props.dismissable &&
            <label className={st.closeButton} htmlFor={this.props.id || this.uniqueID} tabIndex={0} onClick={this.props.onDismiss || (() => {})}>
              <svg width="24" height="24">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M4.874 4.874l14.252 14.252m-14.252 0L19.126 4.874" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
                </svg>
              </svg>
            </label>
          }
          {this.props.content}
        </span>
      </span>
    )
  }
}
